var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c("div", { staticClass: "card-title" }, [
        _vm._v(_vm._s(_vm.$route.meta.title)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 6 } },
                [
                  _vm.hasPermission(["admin:page:add"])
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 8, offset: 10 } },
                [
                  _c("a-input-search", {
                    staticClass: "input-search",
                    attrs: { placeholder: "请输入页面名称" },
                    on: { search: _vm.onSearch },
                    model: {
                      value: _vm.queryParam.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "name", $$v)
                      },
                      expression: "queryParam.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("s-table", {
        ref: "table",
        attrs: {
          rowKey: "page_id",
          loading: _vm.isLoading,
          columns: _vm.columns,
          data: _vm.loadData,
          pageSize: 15,
        },
        scopedSlots: _vm._u([
          {
            key: "page_type",
            fn: function (text) {
              return [
                _c(
                  "a-tag",
                  {
                    attrs: {
                      color: text == _vm.PageTypeEnum.HOME.value ? "green" : "",
                    },
                  },
                  [_vm._v(_vm._s(_vm.PageTypeEnum[text].name))]
                ),
              ]
            },
          },
          {
            key: "action",
            fn: function (item) {
              return _c("span", { staticClass: "actions" }, [
                _vm.hasPermission(["admin:page:edit"])
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(item)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.page_type != _vm.PageTypeEnum.HOME.value &&
                _vm.hasPermission(["admin:page:setHome"])
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleSetHome(item)
                          },
                        },
                      },
                      [_vm._v("设为首页")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.page_type != _vm.PageTypeEnum.HOME.value &&
                _vm.hasPermission(["admin:page:delete"])
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(item)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    )
                  : _vm._e(),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }